import { Component, OnInit, ElementRef, ChangeDetectorRef, PLATFORM_ID, Inject } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AuthService, FacebookLoginProvider, SocialUser, GoogleLoginProvider } from 'angularx-social-login';
import { Login } from './login';
import { Registration } from './registration';
import { AppService } from '../app.service';
import { Verifyotp } from './verifyotp';
import { isPlatformBrowser } from '@angular/common';

import { environment } from "../../environments/environment";

declare var gtag;
declare var fbq;
declare var $;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private service: AppService, private router: Router, private el: ElementRef, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private social: AuthService) {
    if (isPlatformBrowser(this.platformId)) {
      router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          $('#collapsibleNavbar').removeClass('show');
        };
      });
    }
  }

  loading: boolean = false;

  login = new Login();
  registration = new Registration();
  verifyotp = new Verifyotp();

  regErrorMsg: any;
  loginSuccMsg: any;
  loginErrorMsg: any;
  registrationLoader: boolean = false;
  registrationForm: boolean = true;
  loginLoader: boolean = false;
  loginForm: boolean = true;
  verifyOtpForm: boolean = false;
  verifyotpLoader: boolean = false;
  verifymobile_no: string;

  ngOnInit() {
    this.service.loadScript('assets/js/tilt.jquery.min.js');
    this.flipLoginModel();
    this.nextInputFocus();
  }

  facebookLogin() {
    this.loginSuccMsg = "";
    this.loginErrorMsg = "";

    this.social.signIn(FacebookLoginProvider.PROVIDER_ID).then((userdata) => {
      var data = {
        "type": "Web",
        "name": userdata.name,
        "email": userdata.email,
        "gender": "1",
        "user_type": "1",
        "image": userdata.photoUrl,
        "registration_type": "2"
      };

      this.service.post('/socialLogin', data).subscribe(
        (data: any) => {
          if (data[0].error == '0') {
            
            localStorage.setItem('currentUser', JSON.stringify(data[0]));
            $('#loginModal').modal('toggle');
            this.login = new Login();
            this.loginForm = true;
            this.verifyOtpLoginForm = false;
            this.loginSuccMsg = "";
            this.loginSuccMsg = "";

            // if (environment.production) {
            //   gtag('config', 'UA-187473572-1', {
            //     'page_path': 'https://www.propira.com/login'
            //   });
            //   this.service.sendEvents("facebook-login", "facebook-login", "facebook-login");
            //   fbq('init', environment.fbId, {
            //     'track': 'https://www.propira.com/login'
            //   });

            // }

            this.router.navigateByUrl(this.service.redirectUrl);
          } else {
            this.loginErrorMsg = data[0].msg;
          }
        },
        (error: any) => {
          this.loginErrorMsg = error.errorDesc;
        }
      )

      this.social.signOut();

    }, function (error) {
      alert(error);
    });

  }

  googleLogin() {
    this.loginSuccMsg = "";
    this.loginErrorMsg = "";
    this.social.signIn(GoogleLoginProvider.PROVIDER_ID).then((userdata) => {

      var data = {
        "type": "Web",
        "name": userdata.name,
        "email": userdata.email,
        "gender": "1",
        "user_type": "1",
        "image": userdata.photoUrl,
        "registration_type": "3"
      };

      this.service.post('/socialLogin', data).subscribe(
        (data: any) => {
          if (data[0].error == '0') {
            localStorage.setItem('currentUser', JSON.stringify(data[0]));
            $('#loginModal').modal('toggle');
            this.login = new Login();
            this.loginForm = true;
            this.verifyOtpLoginForm = false;
            this.loginSuccMsg = "";
            this.loginSuccMsg = "";
            var redirectUrl = this.service.redirectUrl;
            this.service.redirectUrl = "/";

            // if (environment.production) {
            //   gtag('config', 'UA-187473572-1', {
            //     'page_path': 'https://www.propira.com/login'
            //   });
            //   this.service.sendEvents("google-login", "google-login", "google-login");
            //   fbq('init', environment.fbId, {
            //     'track': 'https://www.propira.com/login'
            //   });
            // }

            this.router.navigateByUrl(redirectUrl);
          } else {
            this.loginErrorMsg = data[0].msg;
          }
        },
        (error: any) => {
          this.loginErrorMsg = error.errorDesc;
        }
      )

      this.social.signOut();
    }, function (error) {
      alert(error);
    });
  }

  get profileDetail() { return JSON.parse(localStorage.getItem('currentUser')); }

  openLoginWindow() {

    if ($(".responsive-menus-menu").hasClass("mobilemenublock")) {
      $('.responsive-menus-menu').toggleClass('mobilemenublock');
    }

    $('#loginModal').modal('toggle');
  }

  regSubmitError: boolean = false;
  resetSignLoginForm() {
    this.login = new Login();
    this.registration = new Registration();
    this.regSubmitError = false;
  }

  flipLoginModel() {

    if (isPlatformBrowser(this.platformId)) {
      var loginButton = document.getElementById("loginButton");
      var registerButton = document.getElementById("registerButton");

      loginButton.onclick = function () {
        document.querySelector("#flipper").classList.toggle("flip");
      };

      registerButton.onclick = function () {
        document.querySelector("#flipper").classList.toggle("flip");
      };
    }

  }

  verifyOtpLoginForm: boolean = false;

  isLoggedIn() {
    return this.service.isLoggedIn();
  }

  chkLogin() {

    this.loginErrorMsg = "";
    this.loginLoader = true;

    this.service.post('/login', this.login).subscribe(data => {

      if (data[0].error == '2') {
        console.log(data);

        this.service.post('/sendOtp', { type: "Web", auth_token: data[0].auth_token }).subscribe();

        this.verifyotp.auth_token = data[0].auth_token;

        var mobile = this.login.email_mobile;
        this.verifymobile_no = mobile.substring(6, 10);

        this.loginForm = false;
        this.verifyOtpLoginForm = true;

      } else if (data[0].error == '0') {
        localStorage.setItem('currentUser', JSON.stringify(data[0]));
        $('#loginModal').modal('toggle');
        this.login = new Login();
        this.loginForm = true;
        this.verifyOtpLoginForm = false;
        this.loginSuccMsg = "";
        this.loginSuccMsg = "";
        var redirectUrl = this.service.redirectUrl;
        this.service.redirectUrl = "/";

        // if (environment.production) {
        //   gtag('config', 'UA-187473572-1', {
        //     'page_path': 'https://www.propira.com/login'
        //   });
        //   this.service.sendEvents("manual-login", "manual-login", "manual-login");
        //   fbq('init', environment.fbId, {
        //     'track': 'https://www.propira.com/login'
        //   });

        //   fbq('track', "login" , {
        //     // content_ids:propertyID,
        //   });
        // }

        this.router.navigateByUrl(redirectUrl);
      } else {
        this.loginErrorMsg = data[0].msg;
      }

      this.loginLoader = false;
    },
      error => {
        this.loginErrorMsg = error.errorDesc;
        this.loginLoader = false;
      }
    );
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.service.redirectUrl = "/profile/myproperty";
    this.router.navigateByUrl('/');
  }

  numberOnly(event, length = 0): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } else if (length > 0) {
      var valueLength = (event.target.value).length;
      if (valueLength >= length) {
        return false;
      }
    } else {
      return true;
    }
  }

  nextInputFocus() {

    if (isPlatformBrowser(this.platformId)) {
      $(document).ready(function () {
        $('body').on('keyup', 'input.change', function (e) {
          var inputs = $('input.change');

          if (e.keyCode == 8) {
            var nameValue = $(this).attr('name');

            if (nameValue != 'pass1') {
              var index = inputs.index(this);
              inputs.eq(index - 1).val('').focus();
            }
          }
          else {
            if ($(this).val().length === this.size) {
              inputs.eq(inputs.index(this) + 1).focus();
            }
          }
        });
      });
    }
  }

  pincodeMsg: any = {};
  pincodeLoader: boolean = false;
  chkPincode(event) {
    this.pincodeLoader = true;
    this.service.post('/checkPincode', { "pincode": event.target.value }).subscribe(
      data => {
        this.pincodeLoader = false;
        this.pincodeMsg = data[0];
      },
      error => {
        this.pincodeLoader = false;
      }
    )
  }

  showRegError() {
    this.regSubmitError = true;
  }

  userRegistration() {
    this.registrationLoader = true;
    this.regErrorMsg = "";

    this.service.post('/registration', this.registration).
      subscribe(data => {
        if (data[0].error == '0') {

          this.service.post('/sendOtp', { type: "Web", auth_token: data[0].auth_token }).subscribe();

          this.verifyotp.auth_token = data[0].auth_token;

          var mobile = this.registration.mobile;
          this.verifymobile_no = mobile.substring(6, 10);
          const eventID =  data[0].id
          if (environment.production) {
             
              this.service.sendEvents("CompleteRegistration", "registration", "Registration");
            

              fbq('track', "CompleteRegistration" , {
                content_ids:eventID,
              });
            }

          this.registrationForm = false;
          this.verifyOtpForm = true;

        } else {
          this.regErrorMsg = data[0].msg;
        }

        this.registrationLoader = false;
      },
        error => {
          this.regErrorMsg = error.errorDesc;
          this.registrationLoader = false;
        }
      );

  }

  genOtpByMobile() {

    this.loginSuccMsg = "";
    this.loginErrorMsg = "";

    if (this.login.email_mobile != '') {

      this.loginLoader = true;

      this.service.post('/sendOtpByMobile', { type: "Web", mobile: this.login.email_mobile })
        .subscribe(data => {

          if (data[0].error == '0') {
            this.loginSuccMsg = data[0].msg;
          } else {
            this.loginErrorMsg = data[0].msg;
          }

          this.loginLoader = false;
        },
          error => {
            this.loginErrorMsg = error.errorDesc;
            this.loginLoader = false;
          }
        );
    } else {
      this.loginErrorMsg = "Please enter your mobile no";
    }

  }

  verifyErrorMsg: any;
  verifySuccessMsg: any;

  resendOtp() {

    this.verifySuccessMsg = "";
    this.verifyErrorMsg = "";
    this.verifyotpLoader = true;

    this.service.post('/resendOtp', { type: "Web", auth_token: this.verifyotp.auth_token })
      .subscribe(data => {

        if (data[0].error == '1') {
          this.verifyErrorMsg = data[0].msg;
        } else {
          this.verifySuccessMsg = data[0].msg;
        }

        this.verifyotpLoader = false;
      },
        error => {
          this.verifyErrorMsg = error.errorDesc;
          this.verifyotpLoader = false;
        }
      );
  }

  matchVerifyOtp() {

    this.verifyErrorMsg = "";
    this.verifyotpLoader = true;

    var otp = (this.verifyotp.pass1) + (this.verifyotp.pass2) + (this.verifyotp.pass3)
    this.service.post('/verifyOtp', { type: "Web", otp: otp, auth_token: this.verifyotp.auth_token })
      .subscribe(
        data => {
          if (data[0].error == '0') {
            localStorage.setItem('currentUser', JSON.stringify(data[0]));
            $('#loginModal').modal('toggle');
            this.registrationForm = true;
            this.verifyOtpForm = false;
            this.loginForm = true;
            this.verifyOtpLoginForm = false;
            this.registration = new Registration();
            this.login = new Login();
            this.verifyotp = new Verifyotp();

            // if (environment.production) {
            //   gtag('config', 'UA-187473572-1', {
            //     'page_path': 'https://www.propira.com/login'
            //   });
            //   this.service.sendEvents("manual-login", "manual-login", "manual-login");
            //   fbq('init', environment.fbId, {
            //     'track': 'https://www.propira.com/login'
            //   });
            // }

          } else {
            this.verifyErrorMsg = data[0].msg;
          }

          this.verifyotpLoader = false;
        },
        error => {
          this.verifyErrorMsg = error.errorDesc;
          this.verifyotpLoader = false;
        }
      );
  }

  onToggle() {
    $('.responsive-menus-menu').toggleClass('mobilemenublock');
  }

  forgotPassword() {
    $('#loginModal').modal('toggle');
    this.router.navigateByUrl("/forgot-password");
  }

  postProperty(){
    if(environment.production){
      this.service.sendEvents("Completepost-property", "post-property", "Post-Property");

      fbq('track', "CompletePost-Property" , {
        content_type: "post-property",
        content_title: this.router.url,
      });
    }
  }

  signIn(){
     if(environment.production){
      this.service.sendEvents("CompletesignIn_signUp", "signIn_signUp", "SignIn_SignUp");

      fbq('track', "CompleteSignIn_SignUp" , {
        content_type: "signIn_signUp",
        content_title: this.router.url,
      });
    }
  }
}
